/**
 * pf
 */
export default
    {
        path: "/ld",
        component: () => import('@/views/MainContent/MainContent'),
        // children: [
        //     {
        //         path: 'member-center/homepage',
        //         name: 'homepage',
        //         component: () => import('@/views/bs/member-center/HomePage'),
        //         meta: {
        //             keepAlive: true,
        //             title: '任务管理'
        //         }
        //     }

        // ]

    }


// WEBPACK FOOTER //
// ./src/router/id.js